import { render, staticRenderFns } from "./StatementsManager.vue?vue&type=template&id=4928120a&scoped=true"
import script from "./StatementsManager.vue?vue&type=script&lang=js"
export * from "./StatementsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928120a",
  null
  
)

export default component.exports